import { Trans } from "react-i18next";

import styles from "./RoomFull.module.css";

export default function RoomFull() {
  return (
    <div className={styles["room-full"]}>
      <div className={styles.message}>
        <Trans i18nKey="RoomFull.message" components={{ br: <br /> }} />
      </div>
    </div>
  );
}
